import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="event-tracker"
export default class extends Controller {
  track (event: Event): void {
    const target = event.target as HTMLElement
    const eventName = target.getAttribute('data-event-name') || ''
    const properties = JSON.parse(target.getAttribute('data-properties') || '{}')

    if (window.segment) {
      window.segment.track(eventName, properties)
    }
  }
}
